import React, { useMemo } from 'react'

import { genreField, newUserFields, peInfoFields } from './peInfoFields'
import { useProfileForm, useUser } from '../../../context'
import DynamicField from '../DynamicFields/DynamicField'
import SectionFields from '../DynamicFields/SectionFields'
import { InputsContainer, RowInformation } from '../styles'

const BasicSection = ({
  allowRoleChange = true,
  allowEmailChange = true,
}: {
  allowRoleChange?: boolean
  allowEmailChange?: boolean
}) => {
  const { onEditionMode, userRole } = useUser()
  const { values, formActions, isNewUser } = useProfileForm()

  const isDisabled = useMemo(() => {
    return isNewUser ? isNewUser : onEditionMode
  }, [isNewUser, onEditionMode])

  const fields = useMemo(
    () => peInfoFields({ state: values, isNewUser: isDisabled }),
    [values, isDisabled],
  )
  const newUser = useMemo(() => newUserFields({ state: values }), [values])
  const genre = useMemo(() => genreField({ state: values }), [values])

  return (
    <>
      {fields.map((field, i) => (
        <RowInformation key={i}>
          {field.rowLeft?.map((item, i) => (
            <DynamicField
              item={item}
              fieldFn={formActions}
              disabled={
                !isDisabled || (item.id === 'email' && !allowEmailChange)
              }
              key={i}
            />
          ))}

          <InputsContainer>
            {field.rowRight?.map((item, i) => (
              <div
                key={i}
                className={`col ${item.fullWidth ? 'col-xl' : 'col-md'}`}
              >
                <DynamicField
                  item={item}
                  fieldFn={formActions}
                  disabled={!isDisabled}
                />
              </div>
            ))}
          </InputsContainer>
        </RowInformation>
      ))}
      {allowRoleChange && (isNewUser || userRole !== 'student') && (
        <SectionFields
          fields={newUser}
          formActions={formActions}
          isDisabled={isDisabled}
        />
      )}
      <SectionFields
        fields={genre}
        formActions={formActions}
        isDisabled={isDisabled}
      />
    </>
  )
}

export default BasicSection
